export default "__VITE_PUBLIC_ASSET__aa3da781__"